<template>
  <div
    :disabled="disabled"
    :class="['tab', { active: active }, customClass]"
    @click="onClick"
  >
    <slot></slot>
  </div>
</template>

<script>
import Btn from "./Btn";

export default {
  name: "Tab",
  components: {
    Btn,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Boolean,
      default: false,
    },
    onClick: {
      type: Function,
      default: () => null,
    },
    customClass: {
      type: String,
      default: ''
    }
  },
};
</script>

<style scoped>
.tab {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  font-weight: 600;
  flex: 1;
  text-transform: uppercase;
  border-radius: 2px;
  color: #3b4c58;
  transition: opacity 0.3s;
}
.tab:not(.active):hover {
  cursor: pointer;
  opacity: 0.5;
}
.tab.active {
  color: #3b4c58;
  background: #f9f9f9;
}
</style>
